import Vue from 'vue'
import Router from 'vue-router'
import store from "@/store/store";

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Switches = () => import('@/views/base/Switches')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tables = () => import('@/views/tables/Tables')
const AdvancedTables = () => import('@/views/tables/AdvancedTables')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Editors
const TextEditors = () => import('@/views/editors/TextEditors')
const CodeEditors = () => import('@/views/editors/CodeEditors')

// Views - Forms
const BasicForms = () => import('@/views/forms/Forms')
const AdvancedForms = () => import('@/views/forms/AdvancedForms')
const ValidationForms = () => import('@/views/forms/ValidationForms')

// Views GoogleMaps
const GoogleMaps = () => import('@/views/GoogleMaps')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')
const Toaster = () => import('@/views/notifications/Toaster')


// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

// Plugins
const Draggable = () => import('@/views/plugins/Draggable')
const Calendar = () => import('@/views/plugins/Calendar')
const Spinners = () => import('@/views/plugins/Spinners')

// Views - UI Kits
const Invoice = () => import('@/views/apps/invoicing/Invoice')
const Compose = () => import('@/views/apps/email/Compose')
const Inbox = () => import('@/views/apps/email/Inbox')
const Message = () => import('@/views/apps/email/Message')

const CourseHistorys = () => import('@/projects/views/E-Port/index')

const CheckInCourse = () => import('@/projects/views/E-Port/checkin/index')
// const EDashborad = () => import('@/projects/views/E-Port/dashboard/index')


const EEstimate = () => import('@/projects/views/E-Performances/Estimate/setting')
const OrganizationCharts = () => import('@/projects/views/E-Performances/Organization/OrganizationCharts')

const Agency = () => import('@/projects/views/E-Performances/Management/Agency/Agency')




const SettingLogin = () => import('@/projects/views/settings/Login')
const SettingMethod = () => import('@/projects/views/settings/Method')

const MUsers = () => import('@/projects/views/E-Port/users/index')
const ELogin = () => import('@/projects/views/Login')
const ALogin = () => import('@/projects/views/Logins')

//
const ManagementAccount = () => import('@/projects/views/E-Performances/Management/Accounts/Index')
const ManagementAdmin = () => import('@/projects/views/E-Performances/Management/Admin/Index')


const EstimateYourself = () => import('@/projects/views/E-Performances/Estimate/index')


const EDashboardS = () => import('@/projects/views/E-Performances/Dashboard/users/index')
const EDashboard = () => import('@/projects/views/E-Performances/Dashboard/Admin/index')

const IDP = () => import('@/projects/views/E-Performances/IndividualDevelopmentPlan/index')


// Report
const RAssessment = () => import('@/projects/views/E-Performances/Reports/assessment/RAssessment.vue')
const RIDP = () => import('@/projects/views/E-Performances/Reports/RIDP')

// Dashboard

const E_Dashboard = () => import('@/projects/views/E-Performances/Dashboard/index.vue')


const voc_index = () => import('@/projects/views/voc/index.vue')

Vue.use(Router)

export default new Router({
  // mode: 'hash', // https://router.vuejs.org/api/#mode
  hash: false,
  mode: "history",
  linkActiveClass: 'open active',
  scrollBehavior: () => ({y: 0}),
  routes: [
    {
      path: '/voc',
      redirect: '/voc/index',
      name: 'Settings',
      component: TheContainer,
      beforeEnter (to, from, next) {
        if(store.getters['personal/profile'].role != 0){
          return next()
        }else{
          localStorage.removeItem('objs');
          return next('/login');
        }
      },
      children: [
        {
          path: 'index',
          name: 'index',
          component: voc_index
        }
      ]
    },
    {
      path: '/report',
      redirect: '/report/assessment',
      name: 'report',
      component: TheContainer,
      children: [
        {
          path: 'assessment',
          name: 'assessment',
          component: RAssessment
        },
        {
          path: 'idp',
          name: 'Individual Development Plan',
          component: RIDP
        }
      ]
    },
    {
      path: '/activitys',
      redirect: '/activitys/history',
      name: 'estimate',
      component: TheContainer,
      children: [
        {
          path: 'history',
          name: 'Setting',
          component: EEstimate
        }
      ]
    },
    {
      path: '/estimate',
      redirect: '/estimate/yourself',
      name: 'Estimates',
      component: TheContainer,
      children: [
        {
          path: 'yourself',
          name: 'Yourself',
          component: EstimateYourself
        },

        {
          path: 'setting',
          name: 'Setting',
          component: EEstimate
        }
      ]
    },

    {
      path: '/management',
      redirect: '/management/organization',
      name: 'Management',
      component: TheContainer,
      beforeEnter (to, from, next) {
        if(store.getters['personal/profile'].role != 0){
          return next()
        }else{
          localStorage.removeItem('objs');
          return next('/login');
        }
      },
      children: [
        {
          path: 'organization',
          name: 'Organization',
          component: OrganizationCharts
        },
        {
          path: 'agency',
          name: 'Agency',
          component: Agency
        }
      ]
    },

    {
      path: '/settings',
      redirect: '/settings/project',
      name: 'Settings',
      component: TheContainer,
      beforeEnter (to, from, next) {
        if(store.getters['personal/profile'].role != 0){
          return next()
        }else{
          localStorage.removeItem('objs');
          return next('/login');
        }
      },
      children: [
        {
          path: 'signin',
          name: 'Signin',
          component: SettingLogin
        },
        {
          path: 'method',
          name: 'Method',
          component: SettingMethod
        }
      ]
    },

    {
      path: '/management',
      redirect: '/management/users',
      name: 'Management',
      component: TheContainer,
      beforeEnter (to, from, next) {
        if(store.getters['personal/profile'].role != 0){
          return next()
        }else{
          localStorage.removeItem('objs');
          return next('/login');
        }
      },
      children: [
        {
          path: 'users',
          name: 'Users',
          component: ManagementAccount
        },
        {
          path: 'admins',
          name: 'Admin',
          component: ManagementAdmin
        }
      ]
    },

    {
      path: '/',
      redirect: '/login',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: EDashboard
        },
        {
          path: 'dashboards',
          name: 'Dashboard',
          component: Dashboard
        },

        {
          path: '/idp',
          name: 'Individual Development Plan',
          component: IDP
        },
      ]
    },

    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: TheContainer,
      children: [

        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },


        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'tables',
          redirect: '/tables/tables',
          name: 'Tables',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'tables',
              name: 'Basic tables',
              component: Tables
            },
            {
              path: 'advanced-tables',
              name: 'Advanced tables',
              component: AdvancedTables
            }
          ]
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'editors',
          redirect: '/editors/text-editors',
          name: 'Editors',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'text-editors',
              name: 'Text Editors',
              component: TextEditors
            },
            {
              path: 'code-editors',
              name: 'Code Editors',
              component: CodeEditors
            }
          ]
        },
        {
          path: 'forms',
          redirect: '/forms/basic-forms',
          name: 'Forms',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'basic-forms',
              name: 'Basic Forms',
              component: BasicForms
            },
            {
              path: 'advanced-forms',
              name: 'Advanced Forms',
              component: AdvancedForms
            },
            {
              path: 'validation-forms',
              name: 'Form Validation',
              component: ValidationForms
            }
          ]
        },
        {
          path: 'google-maps',
          name: 'Google Maps',
          component: GoogleMaps
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'CoreUI Icons',
              component: CoreUIIcons
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            },
            {
              path: 'toaster',
              name: 'Toaster',
              component: Toaster
            }
          ]
        },
        {
          path: 'plugins',
          redirect: '/plugins/draggable',
          name: 'Plugins',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'draggable',
              name: 'Draggable Cards',
              component: Draggable
            },
            {
              path: 'calendar',
              name: 'Calendar',
              component: Calendar
            },
            {
              path: 'spinners',
              name: 'Spinners',
              component: Spinners
            }
          ]
        },

        {
          path: 'apps',
          name: 'Apps',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'invoicing',
              redirect: '/apps/invoicing/invoice',
              name: 'Invoicing',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'invoice',
                  name: 'Invoice',
                  component: Invoice
                }
              ]
            },
            {
              path: 'email',
              redirect: '/apps/email/inbox',
              name: 'Email',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'compose',
                  name: 'Compose',
                  component: Compose
                },
                {
                  path: 'inbox',
                  name: 'Inbox',
                  component: Inbox
                },
                {
                  path: 'message',
                  name: 'Message',
                  component: Message
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/',
      redirect: '/login',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: ELogin
        },

        {
          path: 'logins',
          name: 'Login',
          component: ALogin
        },
      ]
    },

    {
      path: '/logout',
      name: 'logout',
      beforeEnter (to, from, next) {
        localStorage.removeItem('objs');
        return next('/login');
      }
    },
  ],
})
